import containerFuild from '../html-snippets/container-fuild.js';
import css from '../css-snippets/section-tryher-card-compare.js';

const checkIcon = '<span class="tryher-card-compare__icon tryher-card-compare__icon--good">&#10003;</span>';
const closeIcon = '<span class="tryher-card-compare__icon tryher-card-compare__icon--bad">&#215;</span>';

const compareItem = ({ good, bad }) => `
  <div
    data-attribute="tryher-card-compare__item"
    class="tryher-card-compare__item"
  >
    <div
      data-attribute="tryher-card-compare__good"
      class="tryher-card-compare__cell tryher-card-compare__good"
    >
      ${checkIcon}
      <div class="tryher-card-compare__text">${good}</div>
    </div>
    <div
      data-attribute="tryher-card-compare__bad"
      class="tryher-card-compare__cell tryher-card-compare__bad"
    >
      ${closeIcon}
      <div class="tryher-card-compare__text">${bad}</div>
    </div>
  </div>
`;

const items = [
  {
    good: 'Look less tired instantly (not weeks later)',
    bad: 'Takes time to see results (no instant change)',
  },
  {
    good: 'Works on multiple areas at once (not just one spot)',
    bad: 'Only treats one area at a time (you keep chasing new spots)',
  },
  {
    good: 'No needles, no downtime (use it right away)',
    bad: 'Requires injections + recovery (not a casual try)',
  },
  {
    good: 'Looks natural — just more rested (no overdone look)',
    bad: 'Can look unnatural if overdone (hard to fix)',
  },
  {
    good: 'Costs less than one session (no ongoing payments)',
    bad: '$600+ every session (adds up fast)',
  },
  {
    good: "You're in full control (use it or stop anytime)",
    bad: "You're locked into the result (not easy to reverse)",
  },
];

const contentHtml = `
  <div
  data-attribute="tryher-card-compare"
  class="tryher-card-compare container"
  data-bad-position="right"
  data-card-border-color="#FF6099"
  data-card-text-color="#000000"
  data-card-background-color="#FFFFFF"
  style="
    --card-border-color: #ff6099;
    --card-text-color: #000000;
    --card-background-color: #ffffff;
  "
>
  <header
    data-attribute="tryher-card-compare__header"
    class="tryher-card-compare__header"
  >
    <h2 style="text-align: center">
      <strong>Why This Works Before You Spend $600+ On Filler Or Botox</strong>
    </h2>
  </header>
  <div class="tryher-card-compare__layout">
    <div
      data-attribute="tryher-card-compare__good-media"
      class="tryher-card-compare__media tryher-card-compare__good-media"
    >
      <img
        data-attribute="tryher-card-compare__good-image"
        src="https://cdn.skyfastimg.com/images/2026/07/22/image-6a60403d024b2971d303ff67.webp?w=1000"
        alt="Tryher product"
      />
    </div>
    <div
      data-attribute="tryher-card-compare__list"
      class="tryher-card-compare__list"
    >
      ${items.map(compareItem).join('')}
    </div>
    <div
      data-attribute="tryher-card-compare__bad-media"
      class="tryher-card-compare__media tryher-card-compare__bad-media"
    >
      <img
        data-attribute="tryher-card-compare__bad-image"
        src="https://cdn.skyfastimg.com/images/2026/07/22/image-6a60404db1b20564b03fb5aa.webp?w=1000"
        alt="Filler treatment"
      />
    </div>
    <span
      data-attribute="tryher-card-compare__vs"
      class="tryher-card-compare__vs"
      >VS</span
    >
  </div>
</div>
`;

export default containerFuild(contentHtml, css, { backgroundColor: '#FFF7FC', textColor: '#000000' });
